import type { FeaturesFeature } from 'generated/resources/datatable.graphql'
import type { AllFeatureIds } from 'generated/featureIds.generated'

type PartialFeatureNode = Pick<FeaturesFeature, 'name' | 'enabled'>

type FeaturesConnectionWithNodes = {
  nodes?: Array<PartialFeatureNode | null> | null
}

export const isFeatureEnabled = (
  featureName: AllFeatureIds,
  featuresConnection: FeaturesConnectionWithNodes | null | undefined
): boolean => {
  if (!featuresConnection?.nodes) {
    return false
  }

  return featuresConnection.nodes.find((node) => node?.name === featureName)?.enabled ?? false
}
